export function toDate(time?: string | null) {
    if (!time || time.length == 0) {
        return '';
    }
    let tempTime = time.split(":");
    let dt = new Date();
    dt.setHours(+tempTime[0]);
    dt.setMinutes(+tempTime[1]);
    dt.setSeconds(+tempTime[2]);
    return dt.toISOString();
}

export function getTimeFromStr(str: string) {
    var myDate = new Date(str);
    let time = '';
    var minutes = myDate.getMinutes();
    var hours = myDate.getHours();
    if (hours < 10) time = time + "0";
    time += hours + ":";
    if (minutes < 10) time = time + "0";
    time += minutes + ":00";

    return time;
}

export function shortLocalDate(originalDate?: string):string {
    if (!originalDate) {
      return '';
    }
    let dateTime = new Date(originalDate);
    const datePart = dateTime.toLocaleDateString(undefined, { month: "short", day: "numeric" });
    const timePart = dateTime.toLocaleTimeString();
    const result = `${datePart} ${timePart}`;
    return result;
  }